
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/mobile/view-ongoing-orders-and-swap-history",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/mobile/view-ongoing-orders-and-swap-history/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/mobile/view-ongoing-orders-and-swap-history"])
      });
    }
  